/* Polsk katalog for locale-registry-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'control.example': 'Przygotuj fakturę, utwórz dostawcę lub zmień e-mail klienta …',
  'registry.customer': 'Klienci',
  'registry.supplier': 'Dostawcy',
  'registry.product': 'Produkty',
  'registry.description': 'Opis',
  'registry.price': 'Cena jednostkowa bez VAT',
  'registry.type': 'Typ',
  'registry.vat': 'Traktowanie VAT',
  'registry.sku': 'SKU',
  'registry.ean': 'EAN/GTIN',
  'registry.group': 'Grupa produktów',
  'registry.goods': 'Towar',
  'registry.service': 'Usługa',
  'registry.choose': 'Wybierz …',
  'registry.newDraft': 'Nowy wpis – niezapisany',
  'registry.selected': 'Wybrano: {name}',
  'registry.archivedLabel': 'Zarchiwizowane',
  'registry.matches': 'Wyniki: {count}. Wyświetlane: {shown}. Zawęź wyszukiwanie, jeśli pasuje kilka.',
  'registry.working': 'Pracuję w rejestrze …',
  'registry.review': 'Sprawdź dane w panelu rejestru.',
  'registry.done.observed': 'Rejestr jest otwarty, a wyniki są wyświetlane.',
  'registry.done.opened': 'Wpis rejestru został otwarty.',
  'registry.repeatedRead': 'To samo wyszukiwanie w rejestrze zostało już wykonane. Sprawdź wyświetlone wyniki, zanim przejdziesz dalej.',
  'registry.done.applied': 'Pola zostały wypełnione. Zmiany nie są jeszcze zapisane.',
  'registry.done.saved': 'Wpis rejestru został zapisany.',
  'registry.done.archived': 'Wpis rejestru został zarchiwizowany.',
  'registry.done.restored': 'Dostawca jest ponownie aktywny.',
  'registry.done.unchanged': 'Brak nowych zmian do zapisania.',
  'registry.changed': 'Wpis zmienił się od momentu otwarcia. Zamknij panel rejestru i poproś mnie o ponowne wczytanie.',
  'registry.selectFirst': 'Najpierw wyszukaj i wybierz właściwy wpis rejestru.',
  'registry.unsupportedField': 'To pole nie jest tutaj obsługiwane. Użyj zwykłego formularza na stronie.',
  'registry.unsupported': 'Tę czynność trzeba wykonać w zwykłym formularzu na stronie.',
  'registry.advancedProduct': 'Zmiany VAT/typu, subskrypcji i wynajmu trzeba wprowadzać w zwykłym formularzu produktu.',
  'registry.archived': 'Wpis jest zarchiwizowany i nie można go tutaj edytować.',
  'registry.authorization': 'Opisz wprost, co chcesz zapisać, zarchiwizować lub przywrócić.',
  'registry.country': 'Automatyczny zapis w rejestrze jest obecnie obsługiwany dla firm norweskich. Dla tej firmy użyj zwykłego formularza.',
  'registry.uncertain': 'Zapis nie został potwierdzony. Sprawdź wpis na stronie, zanim spróbujesz ponownie.',
  'registry.unsaved': 'W panelu rejestru są niezapisane zmiany. Najpierw je zapisz lub zamknij panel.',
  'registry.duplicate': 'Inny wpis ma tę samą nazwę lub numer organizacyjny. Zamknij panel i wybierz właściwy istniejący wpis albo użyj zwykłego formularza.',
});
